import {
    Button,
    Pagination,
    Popconfirm,
    Spin,
    Table,
    Tag,
    Input,
    message,
    Switch,
    Select,
    Flex,
    Popover,
    Form,
    Drawer,
} from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, dispatchtoast, messageConfiguration } from "../../../utils";
//   import {
//     updateActivationStatus,
//   } from "./orderapiFunctions";
import { addRestro, getordersDetails, getrestroList, gettransactionList, settledAmount, userRegister } from "../../../ApiServices/Apifun";
import {
    DeleteOutlined,
    LoadingOutlined,
    PlusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { render } from "@testing-library/react";
import errorImage from "../../../assets/images/food.png"
import { useDispatch } from "react-redux";
import { setWalletBal } from "../../../Store/B2bslice";


const TransactionList = () => {
    const [transactionData, settransactionData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [currentStatus, setCurrentStatus] = useState();
    const [loader, setloader] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const handleChangeStatus = (id, status) => {
        setIsLoading(true);
        console.log(status);
        const newStatus = status == 1 ? 0 : 1; // Toggle status

        settledAmount(`?transcationId=${id}&isSettled=${newStatus}`)
            .then((response) => {
                if (response.status) {
                    console.log(response.data.vendorBalance);
                    message.success("Status updated successfully");
                    setCurrentStatus(newStatus); // Update local state
                    FetchordersDetails(currentPage);
                    dispatch(setWalletBal(response.data.vendorBalance))
                } else {
                    message.error("Failed to update status");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error updating status:", err);
                message.error("An error occurred while updating the status");
                setIsLoading(false);
            });
    };

    const popoverContent = (id, status) => (
        status == 0 &&
        <div>
            <p>Are you sure you want to settle the amount?</p>
            <Button
                type="primary"
                onClick={() => handleChangeStatus(id, status)}
                disabled={isLoading}
            >
                {isLoading ? <Spin size="small" /> : "Confirm"}
            </Button>
        </div>
    );

    const [isLoading, setIsLoading] = useState(false);
    const [addloader, setaddloader] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [action, setAction] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const { Search } = Input;
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const from = location.state?.from;

    const FetchordersDetails = (page) => {
        setIsLoading(true);
        gettransactionList(`?page=${page}&limit=5&search=${searchTerm}`)
            .then((response) => {
                if (response.status) {
                    settransactionData(response.data || []);
                    setCurrentPage(response.pagination.currentPage || 1);
                    setTotalPages(response.pagination.totalPages || 0);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching order details:", err);
                setIsLoading(false);
            });
    };
    const handlePageChange = (page) => {
        setCurrentPage(page); // Update state to trigger useEffect
    };


    const handleErrorImage = (e) => {

        e.target.src = errorImage

    }
    // console.log("tottaaaaaaaaaaal", totalPage);
    const setwithdrawAction = (id, value) => {
        setAction((prevAction) => ({
            ...prevAction,
            [id]: value,
        }));
    };

    useEffect(() => {
        FetchordersDetails(currentPage);
    }, [currentPage, searchTerm]);

    const handleDrawerClose = () => {
        setOpenModal(false);
    };


    const fileSystem = (employees) => {

        let employees_map = new Map();

        for (let i = 0; i < employees.length; i++) {
            employees_map.set(employees[i].id, { ...employees[i], subordinates: [] })
        }

        let root = null;

        for (let j = 0; j < employees.length; j++) {
            if (employees[j].managerId == null) {
                root = employees_map.get(employees[j].id)
            }
            else {
                let manager = employees_map.get(employees[j].managerId)
                if (manager) {
                    manager.subordinates.push(employees_map.get(employees[j].id))
                }
            }
        }
        return root;
    }

    const employees = [
        { id: 1, name: "John", managerId: null },
        { id: 2, name: "Jane", managerId: 1 },
        { id: 3, name: "Alice", managerId: 1 },
        { id: 4, name: "Bob", managerId: 2 },
        { id: 5, name: "Charlie", managerId: 2 },
    ];

    console.log(fileSystem(employees))

    const columns = [
        // {
        //     title: "Image",
        //     dataIndex: "imageUrl",
        //     key: "imageUrl",
        //     className: "custom-header",
        //     render: (text) => {
        //         return (
        //             <>
        //                 <p className="font-medium w-[120px]">
        //                     <img src={text} onError={handleErrorImage} crossOrigin="anonymous" />
        //                 </p>
        //             </>
        //         );
        //     },
        // },
        {
            title: "Restro. Name",
            dataIndex: "restaurant",
            key: "restaurant",
            className: "custom-header ",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text.name ? text.name : "-"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "CommissionAmount",
            dataIndex: "commissionAmount",
            key: "commissionAmount",
            className: "custom-header",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text ? text : "-"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "CommissionPercentage",
            dataIndex: "commissionPercentage",
            key: "commissionPercentage",
            className: "custom-header whitespace-nowrap",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text ? text : "-"}
                        </p>
                    </>
                );
            },
        },


        {
            title: "PaymentDate",
            dataIndex: "paymentDate",
            key: "paymentDate",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs">
                            {ExtractDate(record.paymentDate)}.{ExtractTime(record.paymentDate)}
                        </p>
                    </>
                );
            },
        },
        {
            title: "SettleAmount",
            dataIndex: "isSettled",
            key: "isSettled",
            className: "custom-header",
            render: (_, record) => (


                <Popover
                    content={popoverContent(record.id, record.isSettled)}
                    trigger="click"
                    placement="bottom"
                >
                    <Tag
                        style={{
                            fontWeight: "bold",
                            color: record.isSettled == 1 ? "green" : "red",
                            backgroundColor: record.isSettled == 1 ? "#e0f5f0" : "#FFE1E1",
                            borderColor: record.isSettled == 1 ? "lightgreen" : "pink",
                            borderRadius: "0px",
                            cursor: "pointer",
                        }}
                    >
                        {record.isSettled == 1 ? "Settled" : "Pending"}
                    </Tag>
                </Popover>
            ),
        },
    ];
    return (
        <div>
            <div className="flex items-end justify-end m-2">
                <Search
                    placeholder="search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "26%" }}
                />
            </div>
            <div
                //   style={{ maxHeight: "540px", overflow: "auto" }}
                className="shadow-sm shadow-gray-300"
            >
                {" "}
                <Table
                    // title={() => (
                    //     <div className="flex justify-end">
                    //         <Button onClick={() => setOpenModal(true)} className="bg-rgbaprimary8 text-white font-semibold rounded-none h-10">
                    //             {" "}
                    //             <PlusOutlined /> Add Restro
                    //         </Button>
                    //     </div>
                    // )}
                    bordered={true}
                    loading={isLoading}
                    columns={columns}
                    dataSource={transactionData}
                    pagination={false}
                    className="w-screen sm:w-screen   custom-table-header"
                    size="small"
                />
            </div>
            <Pagination
                className="mt-2 text-xs w-full flex justify-end"
                total={totalPages * 10} // Assuming 10 items per page
                showTotal={(total, range) =>
                    `${range[0]}-${range[1]} of ${totalPages * 10} items`
                }
                onChange={handlePageChange}
                defaultPageSize={10}
                current={currentPage}
            />
        </div>
    );
};
export default TransactionList;
